export const footer_i18n = {
    text1: "Privacy",
    text2: "Terms",
    text3: "Site Map"
};